import BrandDetails from "./BrandDetails";

export default BrandDetails;
